export default "__VITE_ASSET__CVbS2kCA__"